<template>
  <div class="overlay" v-bind:class="{ visible: show }">
    <div class="overflow">

      <div class="close" @click="close">
        <svg width="146px" height="146px" viewBox="0 0 146 146" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <polygon data-v-1a4c249e="" id="Path" fill="#000000" points="73 64.5147186 136.63961 0.875108319 145.124892 9.36038969 81.4852814 73 145.124892 136.63961 136.63961 145.124892 73 81.4852814 9.36038969 145.124892 0.875108319 136.63961 64.5147186 73 0.875108319 9.36038969 9.36038969 0.875108319"></polygon>
          </g>
        </svg>
      </div>

      <div class="top-bar">
        <div class="inner">
          <div class="slides-count" style="display: none">1/1</div>
          <div class="title">
            {{titre}}<span v-if="serie">{{serie}} / {{total}}</span>
          </div>
        </div>
      </div>

      <div class="image-wrapper">
        <img :src="'pics/'+image" @click="close">
      </div>

      <div class="bottom-bar"></div>

    </div>
  </div>
</template>

<script>

export default {

  props: {
    show: Boolean,
    titre: String,
    image: String,
    serie: Number,
    total: Number
  },

  data: () => ({
    visible: false
  }),

  methods: {
    close() {
      this.$emit('closed')
    }
  }
}

</script>

<style scoped>

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #fff;
  transition: opacity 600ms cubic-bezier(0.77, 0, 0.21, 1), visibility 600ms cubic-bezier(0.77, 0, 0.21, 1), -webkit-transform 600ms cubic-bezier(0.77, 0, 0.21, 1);
  transition: opacity 600ms cubic-bezier(0.77, 0, 0.21, 1), visibility 600ms cubic-bezier(0.77, 0, 0.21, 1), transform 600ms cubic-bezier(0.77, 0, 0.21, 1);
  transition: opacity 600ms cubic-bezier(0.77, 0, 0.21, 1), visibility 600ms cubic-bezier(0.77, 0, 0.21, 1), transform 600ms cubic-bezier(0.77, 0, 0.21, 1), -webkit-transform 600ms cubic-bezier(0.77, 0, 0.21, 1);
  opacity: 0;
  visibility: hidden;
  -webkit-transform: scale3d(0.97, 0.97, 0.97);
  transform: scale3d(0.97, 0.97, 0.97);
  z-index: 100;
}

.overlay.visible {
  opacity: 1;
  visibility: visible;
  -webkit-transform: scale3d(1, 1, 1);
  transform: scale3d(1, 1, 1);
}

.overflow {
  position: absolute;
  overflow: none;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  min-width: 320px;
}

.close {
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
  height: 50px;
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.close svg {
  width: 18px;
  height: 18px;
}

.swiper-component.loaded {
  opacity: 1;
}

.swiper-component {
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: opacity 500ms ease;
  position: relative;
}

.top-bar {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  padding: 0 10px;
  height: 75px;
}

.top-bar .inner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin: 0 auto;
}

.slides-count {
  border: 1px solid;
  margin-right: 7px;
  padding: 0.2em 0.7em;
}

.top-bar .title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-transform: uppercase;
}

.top-bar .title span {
  margin-left: 20px;
  color: #888;
}

.bottom-bar {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
  height: 60px;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  transition-property: -webkit-transform;
  transition-property: transform;
  transition-property: transform, -webkit-transform;
  box-sizing: content-box;
}

.swiper-container .swiper-notification {
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;
  opacity: 0;
  z-index: -1000;
}

.arrow.arrow-next {
  right: 20px;
}

.arrow.arrow-prev {
  left: 20px;
}

.arrow {
  width: 60px;
  height: 60px;
  line-height: 60px;
}

.arrow {
  z-index: 1;
  position: absolute;
  top: 0;
  opacity: 0;
  visibility: hidden;
  transition: all 200ms ease;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: tran(-50%);
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border-radius: 100px;
  background: #fff;
}

.image-wrapper {
  position: absolute;
  top: 75px;
  bottom: 75px;
  left: 15px;
  right: 15px;
  vertical-align: middle;
}

.image-wrapper img {
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
  object-fit: contain;
  cursor: pointer;
}

</style>
